import { render, staticRenderFns } from "./LogStok.vue?vue&type=template&id=81822d76&"
import script from "./LogStok.vue?vue&type=script&lang=js&"
export * from "./LogStok.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports